import type { FC } from 'react';

import { HelpText } from '@pp/core/src/services/helpTranslations/reactBindings/HelpText';
import { useUITranslation } from '@pp/core/src/services/uiTranslations/reactBindings/hooks';
import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';

export const CrashHelpChapterReturnToPlayerConnected: FC = () => {
  const rtp = useConfigSlice.getRtp();
  const tableId = useConfigSlice.tableId() ?? '';
  const tableName = useConfigSlice.tableName() ?? '';
  if (!rtp) return null;
  const tName = useUITranslation(tableName) ?? tableName;

  return (
    <div>
      <p>
        <HelpText
          dynamicValues={{
            rtp_optimal_return: `${rtp?.[tableId] ?? rtp?.rtp}%`,
            TABLE_NAME: tName,
          }}
          tk="returnToPlayer.highFlyerRTP"
          markdown
        />
      </p>
    </div>
  );
};
